import React from "react";
import "./Help.css";

const Help = () => {
  return (
    <div className="help-container">
      <div className="help-header">
        <h1>WE WILL HELP YOU</h1>
      </div>
      <hr className="help-hr"/>
      <div className="service-help-flex">
      <div className="help-content">
        <p>
          We pride ourselves on delivering high-quality custom software solutions that
          drive business growth and success. You gain a trusted partner who is
          dedicated to understanding your unique requirements and delivering
          innovative, secure software tailored to your needs.
        </p>
      </div>
      <div className="vertical-line-help"></div>
      <div className="help-features">
        <div className="feature-item">
          <div className="checkbox-help">✔</div>
          <div>
            <h3>Security and reliability</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit, etiam dis sociosqu</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="checkbox-help">✔</div>
          <div>
            <h3>High-quality code</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit, etiam dis sociosqu</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="checkbox-help">✔</div>
          <div>
            <h3>Using latest technologies</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit, etiam dis sociosqu</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="checkbox-help">✔</div>
          <div>
            <h3>Scalability</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit, etiam dis sociosqu</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="checkbox-help">✔</div>
          <div>
            <h3>Cost-efficiency</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit, etiam dis sociosqu</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="checkbox-help">✔</div>
          <div>
            <h3>Full-cycle development</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit, etiam dis sociosqu</p>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Help;